import React from "react";
import { Card, CardBody, Row, Col, Nav, NavItem } from "reactstrap";
import { Link } from "react-router-dom";
import { Page } from "components/common";
import { HoverCard } from "components";
import img1 from "../../assets/images/organizationinfo-icon.svg";
import img2 from "../../assets/images/attendancerules-icon.svg";
import img3 from "../../assets/images/allowancerules-icon.svg";
import img4 from "../../assets/images/branchesdepartments-icon.svg";
import img5 from "../../assets/images/endofservice-icon.svg";
import img6 from "../../assets/images/documenttype-icon.svg";
import img7 from "../../assets/images/employeetype-icon.svg";
import img8 from "../../assets/images/publicholidays.svg";
import img9 from "../../assets/images/holidayssettings.svg";
import img10 from "../../assets/images/payrunsettings.svg";
import img11 from "../../assets/images/deductions-icon.svg";
import provisionImg from "../../assets/images/provisions-icon.svg";
import taxImg from "../../assets/images/icons8-tax-32.png";
import { Trans } from "react-i18next";

const SettingsManagement = ({ match, t }) => {

  return (
    <div className="holder">
      <Page title={t("Payroll Settings")} className="general-settings">
        <hr />
        <Row>
          <Nav className="w-100">
            <Col md={6}>
              <HoverCard
                imgSrc={img4}
                to={`/payroll-new/branches-departments`}
                title="Branches and departments"
                description="Organize workforce branches and departments."
              />
            </Col>
            <Col md={6}>
              <HoverCard
                imgSrc={img10}
                to={`/payroll/settings`}
                title="Payroll Accounts Settings"
                description="Configure payroll account details for financial transactions."
              />
            </Col>
          </Nav>
        </Row>
        <div>
        <span className="d-print-none card-title"><Trans>Payroll Policies</Trans></span>
        <hr/>
        <Row>
          <Nav className="w-100">
            <Col md={6}>
              <HoverCard
                imgSrc={img8}
                to={`/payroll-new/public-holidays`}
                title="Public Holidays"
                description="Manage official holidays for leave calculations and payroll."
              />
            </Col>
            <Col md={6}>
              <HoverCard
                imgSrc={img3}
                to={`/payroll-new/allowance-rules`}
                title="Allowance Rules"
                description="Define Allowance rules to align with your policies."
              />
            </Col>
            <Col md={6}>
              <HoverCard
                imgSrc={img11}
                to={`/payroll-new/deductions`}
                title="Deductions"
                description="Set up deduction rules for salaries and compliance."
              />
            </Col>
            <Col md={6}>
              <HoverCard
                imgSrc={provisionImg}
                to={`/payroll/provisions`}
                title="Provisions"
                description="Customize provisions for employee benefits."
              />
            </Col>
            <Col md={6}>
              <HoverCard
                imgSrc={taxImg}
                to={`/payroll/tax_rules`}
                title="Tax Rules"
                description="Customize Tax rules"
              />
            </Col>
              <Col md={6}>
                <HoverCard
                  imgSrc={img2}
                  to={`/payroll-new/shift`}
                  title="Shift List"
                  description="Manage shifts for employees."
                />
              </Col>
          </Nav>
        </Row>
        </div>
      </Page>
    </div>
  );
};

export default SettingsManagement;
